import type {
  GoogleIdConfiguration,
  GooglePromptMomentNotification,
} from "src/types/google-one-tap";

export const GOOGLE_GSI_CLIENT_SRC = "https://accounts.google.com/gsi/client";

function getAccountsId() {
  if (typeof window === "undefined") {
    return undefined;
  }

  return window.google?.accounts?.id;
}

export function isOneTapSupported(): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  return !!window.navigator?.credentials;
}

export function initializeOneTap(config: GoogleIdConfiguration): void {
  getAccountsId()?.initialize(config);
}

export function promptOneTap(
  listener: (notification: GooglePromptMomentNotification) => void
): void {
  getAccountsId()?.prompt(listener);
}

export function cancelOneTap(): void {
  getAccountsId()?.cancel();
}

export function disableOneTapAutoSelect(): void {
  getAccountsId()?.disableAutoSelect();
}
